import 'nprogress/nprogress.css';
import '@crehana/next/dist/main.css';
import '../../styles/globals.css';
import '@crehana/ui/dist/crehana-ui.min.css';

import { NextPage } from 'next';
import { ReactElement, ReactNode } from 'react';

import { App } from '@crehana/next';
import type { MyAppProps } from '@crehana/next';

type NextPageWithLayout = NextPage & {
  getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = MyAppProps & {
  Component: NextPageWithLayout;
};

const MyApp: React.FC<AppPropsWithLayout> = props => {
  const getLayout = props.Component.getLayout ?? (page => page);

  return (
    <App
      {...props}
      customRender={({ Component }) => {
        return getLayout(<Component {...props.pageProps} err={props.err} />);
      }}
    />
  );
};

export default MyApp;
